import { Component, ViewChild } from '@angular/core';
import { ShowView } from '@common/views';
import { ApplicantMessage } from '@models/recruiting/applicant-message.model';
import { NotifyService } from '@app/services/notify.service';
import { BaseForm } from '@forms/base.form';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { AuthService } from '@app/services';
import { ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './applicant-message-store.template.html',
})
export class ApplicantMessageStoreView extends ShowView {
    @ViewChild('confirmationModal') confirmationModal: DeprecatedConfirmationDialogComponent;

    isLoading = false;

    applicantMessage: ApplicantMessage = new ApplicantMessage({
        replyTo: this.auth.account.email,
    });

    constructor(
        private auth: AuthService,
        private notify: NotifyService,
        private route: ActivatedRoute
    ) {
        super();

        this.applicantMessage.jobPostingId = +this.route.snapshot.params?.jobPostingId || null;
    }

    onSave(applicantMessageForm: BaseForm): void {
        applicantMessageForm.submit();

        if (!applicantMessageForm.valid) {
            return;
        }

        this.confirmationModal.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;

            this.applicantMessage
                .param('jobPosting', this.applicantMessage.jobPostingId)
                .create()
                .then(() => {
                    this.notify.success('applicant-tracker.emailSent');
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.notify.error(err.message);
                    this.isLoading = false;
                });
        });
    }

    onSendTest(applicantMessageForm: BaseForm): void {
        applicantMessageForm.submit();

        if (!applicantMessageForm.valid) {
            return;
        }

        this.isLoading = true;

        this.applicantMessage.sendTest = true;
        this.applicantMessage
            .param('jobPosting', this.applicantMessage.jobPostingId)
            .create()
            .then(() => {
                this.notify.success({
                    key: 'applicant-tracker.testHasBeenSentTo',
                    params: {
                        email: this.auth.account.email,
                    },
                });
                this.applicantMessage.sendTest = false;
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message);
                this.applicantMessage.sendTest = false;
                this.isLoading = false;
            });
    }

    onCancel(): void {}

    onDelete(): void {}
}
